import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import heroImage from "@/assets/hero-couple.jpg";

const Hero = () => {
  const { t } = useTranslation();

  const handleScheduleClick = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-end pb-36 sm:pb-20 md:items-center md:pb-0 overflow-hidden" aria-label="Hero section">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src={heroImage}
          alt="Happy patients with beautiful smiles at LS Dental Clinic"
          className="w-full h-full object-cover object-[60%_center]"
          width={1920}
          height={1080}
          loading="eager"
          fetchPriority="high"
          decoding="async"
          style={{ aspectRatio: '16/9' }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background/90 via-background/70 to-background/50"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-3xl">
          <h1 className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-bold text-foreground mb-4 sm:mb-6 leading-tight">
            {t('hero.title')}
            <br />
            <span className="text-primary">{t('hero.titleHighlight')}</span>
          </h1>
          <p className="text-muted-foreground mb-6 sm:mb-8 max-w-xl">
            <span className="text-lg sm:text-xl md:text-2xl block mb-2">
              {t('hero.subtitle1')} <span className="font-bold">{t('hero.subtitle1Bold')}</span>{t('hero.subtitle1Rest')}
            </span>
            <span className="text-base sm:text-lg md:text-xl">
              {t('hero.subtitle2')}
            </span>
            <span className="text-sm sm:text-base text-muted-foreground block mt-2">
              {t('hero.location')}
            </span>
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
            <Button 
              size="lg" 
              className="text-sm sm:text-base px-6 sm:px-8 py-5 sm:py-6"
              onClick={handleScheduleClick}
            >
              {t('hero.cta')}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
